import { render, staticRenderFns } from "./policyFile.vue?vue&type=template&id=a25e094c&scoped=true&"
import script from "./policyFile.vue?vue&type=script&lang=js&"
export * from "./policyFile.vue?vue&type=script&lang=js&"
import style0 from "./policyFile.vue?vue&type=style&index=0&id=a25e094c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25e094c",
  null
  
)

export default component.exports